module.exports = {
  layout: 'column',
  themeName: 'blue-black',
  background: 'none',
  columnStyle: 'card',
  fixedHeader: true,
  showProgressBar: true,
  showTabs: true,
  tabsBarStyle: 'smooth',
  showTabsIcon: true,
  showLanguage: true,
  showRefresh: true,
  showSearch: false,
  showTheme: false,
  showNotice: false,
  showFullScreen: true,
  showThemeSetting: false,
  foldSidebar: false,
  showPageTransition: true,
  showLock: false,
}
